import QuestWhiteLogo from "../../../assets/images/QuestWhiteLogo.svg";
import { checkForCloseChat, formatDate } from "./helperfunction";

import { HelphubStyleConfig } from "../CustomHelpHub.type";
import { WrapLinkText } from "./WrapLinkText";
import HelphubSvg from "../CustomHelphubSvg";

interface QuestThemeData {
  accentColor?: string;
  borderRadius?: string;
  buttonColor?: string;
  images?: string[];
}

type Props = {
  message: {
    senderRole: "ASSISTANT" | "USER" | "ADMIN" | "SYSTEM";
    content: string;
    timestamp: string;
    _id?: string;
  };
  entityImage: string;
  index: number;
  fontSize: number | string;
  setOpenCloseChatPopup: (value: boolean) => void;
  setIfSatisfied: (value: boolean) => void;
  selectedConversationId: string;
  setData: (value: any) => void;
  isAdminCloseChat: boolean;
  isCloseChatAdmin: boolean;
  setCloseChatAdmin: (value: boolean) => void;
  QuestThemeData?: QuestThemeData;
  styleConfig?: HelphubStyleConfig;
};

const HandleAdminChat = ({
  message,
  entityImage,
  index,
  setOpenCloseChatPopup,
  setIfSatisfied,
  selectedConversationId,
  setData,
  isAdminCloseChat,
  isCloseChatAdmin,
  QuestThemeData,
  styleConfig,
}: Props) => {





  const formatMessage = (messageText: string) => {
    return messageText.split(/\n\n+/).map((para, idx) => {
      if (para.trim() === "") {
        return <br key={`br-${idx}`} />;
      }
      return WrapLinkText(para, idx, styleConfig, QuestThemeData);
    });
  };

  const handleCloseChat = () => {
    const data = localStorage.getItem("chatSatisfied");
    const parsedData = data ? JSON.parse(data) : {};
    parsedData[selectedConversationId] = {
      isSatisfied: true,
      messageId: message._id,
    };
    localStorage.setItem("chatSatisfied", JSON.stringify(parsedData));
    setData((prev: Props["message"][]) =>
      prev.filter((ele) => ele._id !== message._id)
    );
    setIfSatisfied(false);
  };

  const renderMessageContent = () => {
    if (
      message.content.includes("https://quest-media-storage-bucket") ||
      message.content.includes("https://pin.questprotocol.xyz/ipfs")
    ) {
      return (
        <div className="chat-coversion-img">
          <img src={message.content} alt="" />
        </div>
      );
    }
    return formatMessage(message.content);
  };

  return (
    <>
      {(message.senderRole === "ASSISTANT" || message.senderRole === "ADMIN") &&
        checkForCloseChat(message?.content).closeChatTag !== "CLOSE_CHAT" && (
          <div className="custom-chat-profile-img-receiver">
            <HelphubSvg type="ava-icon" />
          </div>
        )}

      {(message.senderRole === "ASSISTANT" || message.senderRole === "ADMIN") &&
        checkForCloseChat(message?.content)?.closeChatTag == "CLOSE_CHAT" &&
        !isAdminCloseChat &&
        !isCloseChatAdmin && (
          <div className="chat-profile-img-receiver">
            <img src={entityImage || QuestWhiteLogo} alt="Entity" />
            {/* <img
              src={message.senderRole === "ASSISTANT" ? aiTag : adminTag}
              id="chat-profile-img-receiver-tag"
              alt="Tag"
            /> */}
            {message.senderRole == "ASSISTANT" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="13"
                  height="13"
                  rx="6.5"
                  fill={QuestThemeData?.accentColor || "#9035FF"}
                />
                <rect
                  x="0.5"
                  y="0.5"
                  width="13"
                  height="13"
                  rx="6.5"
                  stroke="white"
                />
                <path
                  d="M9.82478 5.41875H9.33746L9.82478 4.4731L9.33746 4.23655L8.36224 5.41818H7.26534V4.70909L7.87436 4.47254V4L5.9245 4.00055V4.47309L6.53409 4.70964V5.41873H5.43719L4.46254 4.23711L3.97465 4.47311L4.46254 5.41875H3.97465C3.43648 5.41875 3 5.84143 3 6.36439V7.30948C3 8.61464 4.09004 9.67273 5.43717 9.67273H8.36224C9.70994 9.67273 10.8 8.61464 10.8 7.30948V6.36439C10.8 5.84143 10.363 5.41875 9.82478 5.41875ZM5.55885 7.782C5.22178 7.782 4.94984 7.51775 4.94984 7.1909C4.94984 6.86405 5.22178 6.5998 5.55885 6.5998C5.89593 6.5998 6.16844 6.86405 6.16844 7.1909C6.16844 7.5183 5.8965 7.782 5.55885 7.782ZM8.24056 7.782C7.90349 7.782 7.63155 7.51775 7.63155 7.1909C7.63155 6.86405 7.90349 6.5998 8.24056 6.5998C8.57763 6.5998 8.85015 6.86405 8.85015 7.1909C8.85015 7.5183 8.57763 7.782 8.24056 7.782Z"
                  fill="white"
                />
              </svg>
            ) : (
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="13"
                  height="13"
                  rx="6.5"
                  fill={QuestThemeData?.accentColor || "#9035FF"}
                />
                <rect
                  x="0.5"
                  y="0.5"
                  width="13"
                  height="13"
                  rx="6.5"
                  stroke="white"
                />
                <g clip-path="url(#clip0_11529_4203)">
                  <path
                    d="M9.4502 3.6167H4.5502C3.87236 3.6167 3.3252 4.15978 3.3252 4.82945V9.28437C3.3252 9.95403 3.87236 10.4971 4.5502 10.4971H4.86053C5.1872 10.4971 5.49753 10.6237 5.7262 10.8524L6.42445 11.5424C6.74295 11.8569 7.26153 11.8569 7.58003 11.5424L8.27828 10.8524C8.50695 10.6237 8.82136 10.4971 9.14395 10.4971H9.4502C10.128 10.4971 10.6752 9.95403 10.6752 9.28437V4.82945C10.6752 4.15978 10.128 3.6167 9.4502 3.6167ZM7.0002 5.14795C7.52695 5.14795 7.95161 5.57262 7.95161 6.09937C7.95161 6.62612 7.52695 7.05078 7.0002 7.05078C6.47345 7.05078 6.04878 6.62203 6.04878 6.09937C6.04878 5.57262 6.47345 5.14795 7.0002 5.14795ZM8.09453 8.94953H5.90586C5.57511 8.94953 5.3832 8.58203 5.56695 8.30845C5.84461 7.89603 6.38361 7.61837 7.0002 7.61837C7.61678 7.61837 8.15578 7.89603 8.43345 8.30845C8.6172 8.58203 8.4212 8.94953 8.09453 8.94953Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_11529_4203">
                    <rect
                      width="9.8"
                      height="7.7"
                      fill="white"
                      transform="translate(2.1001 2.80005)"
                    />
                  </clipPath>
                </defs>
              </svg>
            )}
          </div>
        )}

      {checkForCloseChat(message?.content)?.closeChatTag === "CLOSE_CHAT" ? (
        !isAdminCloseChat && !isCloseChatAdmin ? (
          <div>
            <div className="q-helphub-satisfied-user-reply2">
              <div
                className="custom-message custom-receiver-role"
                id="q-helphub-satisfied-user-reply"
              >
                <p>
                  {checkForCloseChat(message?.content)?.regularString ||
                    "Are you satisfied, or do you have any other queries? If not, would you like to close the chat?"}
                </p>
              </div>
              <div className="q-helphub-satisfied-close-chat">
                <div
                  className="q-helphub-close-chat"
                  onClick={() => setOpenCloseChatPopup(true)}
                >
                  Close chat
                </div>
                <div
                  className="q-helphub-close-chat-continue"
                  onClick={handleCloseChat}
                >
                  Continue chat
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )
      ) : (
        <div key={index}>
          <div
            className={`custom-message ${message.senderRole === "USER" ? "sender-role" : message.senderRole === "SYSTEM" ? "custom-system-role" : "custom-receiver-role"
              }`}
          >
            {renderMessageContent()}
          </div>
        </div>
      )}
    </>
  );
};

export default HandleAdminChat;
